import { isUndefined } from "../../predicate/predicate.js";
import "../../i18n.js";
//#region src/dom/locale/effective-locale.ts
/** Resolves locale: explicit non-empty value → ambient `lang` → {@link fallback}. */
function effectiveLocale(explicitLocale, ambientLang, fallback = "en") {
	if (!isUndefined(explicitLocale) && explicitLocale.trim() !== "") return explicitLocale;
	if (!isUndefined(ambientLang) && ambientLang.trim() !== "") return ambientLang;
	return fallback;
}
//#endregion
export { effectiveLocale };

//# sourceMappingURL=effective-locale.js.map